import React from "react";
import {Box, CircularProgress, Icon, Typography} from "@mui/material";
import DeepBIoSVG from "../asset/img/deepbio_logo.svg";
import {Science} from "@mui/icons-material";
import {morphleBaseTheme1} from "../component/gammaviewer/themes";
import logo from "../asset/img/logo.png";
import logo_bw from "../asset/img/logo_bw.png";
import logo_square from "../asset/img/logo_square.png";
import defaultBarcodeImg from "../asset/img/default_barcode.png";
import defaultPreviewImg from "../asset/img/default_preview.png";

import cookie from "react-cookies";
import {isRunningFromSite, isTrue, notNull} from "./utils";
import {LoadingOutlined} from "@ant-design/icons";

// ---------- Remote URL consts starts -------
export const remoteUrlPrefix = (notNull(process.env.REACT_APP_IS_CLOUD) && isTrue(process.env.REACT_APP_IS_CLOUD)) ? `/${process.env.REACT_APP_REMOTE_URL}` : notNull(process.env.REACT_APP_REMOTE_URL) ? `/${process.env.REACT_APP_REMOTE_SERVER}/${process.env.REACT_APP_REMOTE_URL}` : '/remote/dummy';
export const remoteSite = ['www.morphlelabs.com', 'morphlelabs.com'];
// ---------- Remote URL consts ends ---------

export const isBloodDebug = cookie.load('deployment_mode') !== "cloud" && (process.env.DEBUG_DUMP_ANNOTATION || '').toLowerCase() === "true"

export const MorphleLogo = logo;
export const MorphleLogoBW = logo_bw;
export const MorphleLogoSquare = logo_square;

export const defaultBarcode = defaultBarcodeImg;
export const defaultPreview = defaultPreviewImg;



export const globalUrlPrefix = isRunningFromSite() ? remoteUrlPrefix : '';

export const globalConfigurations = JSON.parse(localStorage.getItem('global_configurations')) || {};

export const openInNewTabType = {
    CASE: 'case',
    SLIDE: 'slide'
}

export const cameraModeTypes = {
    LIVE_CAMERA: "live_camera",
    QUADRANT_MODE: "quadrant_mode"
}

export const cassetteType = {
    SIX_1_BY_3_SLIDES: "SIX_1_BY_3_SLIDES",
    TWO_2_BY_3_SLIDES: "TWO_2_BY_3_SLIDES"
}

// should match SlideType data structure values in scano
export const slideType = {
    SLIDE_1_BY_3_INCH: "SLIDE_1_BY_3_INCH",
    SLIDE_2_BY_3_INCH: "SLIDE_2_BY_3_INCH"
}

export const specimenType = {
    HNE_TISSUE: "HNE_TISSUE",
    BLOOD: "BLOOD",
    IHC: "IHC",
    BM: "BM",
    PAP: "PAP",
    AUTO: "AUTO"
}

export const cloudProvider = {
    AWS: "AWS",
    GCLOUD: "GCLOUD"
}

export const deploymentMode = {
    OFFLINE: "offline",
    CLOUD: "cloud"
}


export const scanSpeed = {
    SLOW: "SLOW",
    MEDIUM: "MEDIUM",
    FAST: "FAST",
    ZSTACK: "ZSTACK",
}

export const objectiveType = {
    HUNDRED_X: 'HUNDRED_X',
    TWENTY_X: 'TWENTY_X',
    FORTY_X: 'FORTY_X',
    FOUR_X: 'FOUR_X'
}

export const slideViewType = {
    CASEVIEW: 'caseview',
    DASHBOARDVIEW: 'dashboardview'
}

export const slotCorners = {
    TL: 'TL',
    TR: 'TR',
    BL: 'BL',
    BR: 'BR'
}

export const draggableType = {
    SLIDE_VIEWER: 'SLIDE_VIEWER',
    MANUAL_MODE: 'MANUAL_MODE'
}

export const previewTuningTestAppType = {
    STITCHED_IMAGE: 'stitched_image',
    FULL_SLOT_IMAGE: 'full_slot_image',
    CROPPED_SLOT_IMAGE: 'cropped_slot_image'
}

export const maxZIndex = 2147483647;

export const qcSettingsAppConsts = {
    LEVER_REDUCTION: 'leverReduction',
    MIN_X_SOFT_LIMIT: 'minXSoftLimit',
    MAX_X_SOFT_LIMIT: 'maxXSoftLimit',
    MIN_Y_SOFT_LIMIT: 'minYSoftLimit',
    MAX_Y_SOFT_LIMIT: 'maxYSoftLimit',
    MIN_Z_SOFT_LIMIT: 'minZSoftLimit',
    MAX_Z_SOFT_LIMIT: 'maxZSoftLimit',
    X_STEPS_PER_MM: 'xStepsPermm',
    Y_STEPS_PER_MM: 'yStepsPermm',
    Z_STEPS_PER_MM_ON_SCREW: 'zStepsPermmOnScrew',
    X_MAX_SPEED: 'xMaxSpeed',
    Y_MAX_SPEED: 'yMaxSpeed',
    Z_MAX_SPEED: 'zMaxSpeed',
    X_MAX_ACCEL: 'xMaxAccel',
    Y_MAX_ACCEL: 'yMaxAccel',
    Z_MAX_ACCEL: 'zMaxAccel',
}

export const liveModeLoadingMessages = {
    MAIN_LIGHT_ON: 'Turning Main Light On...',
    MAIN_LIGHT_OFF: 'Turning Main Light Off...',
    DROP_DISTANCE_AF: 'Doing Coarse Focus...',
    AUTO_FOCUS: 'Doing Fine Focus...',
    TAKING_IMAGES: 'Saving Image...',
    SET_GAMMA_VALUE: 'Setting Gamma value...',
    CHANGE_LUT_VALUE: 'Changing LUT value...',
    SET_WB: 'Setting WB...',
    MOVE: 'Moving to the specified position...',
    TAKING_PREVIEW: 'Taking Preview...',
    LOADING_IMAGE: 'Loading Image...',
    EJECTING_SLIDE: 'Ejecting Slide...',
    SETTINGS_COARSE_Z_LEVEL: 'Setting Coarse Focus Z Level...',
    DOWNLOADING_IMAGES: 'Downloading Images...',
    SWITCHING_OBJECTIVE: 'Switching Objective...',
    MODIFYING_SETTINGS: 'Modifying Settings...',
}

export const previewCameraType = {
    NORMAL: 'NORMAL',
    FOUR_X: 'FOUR_X',
    PREVIEW_CAMERA_NO_OBJ: 'PREVIEW_CAMERA_NO_OBJ',
}

export const monthMapping = {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
    13: 'Total'
}

export const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

export const mapLayerTypes = {
    STITCHED_LAYER_NAME: 'stitched_layer',
    TILED_LAYER_NAME: 'tiled_layer',
    ANNOTATION_LAYER_NAME: 'annotation_layer',
    BLOOD_ANNOTATION_LAYER_NAME: 'BLOOD_ANNOTATION_LAYER_NAME',
    ANNOTATION_LAYER_NEW: 'annotation_layer_new',
    BRAIN_META_VIEWER_ANNOTATION_LAYER_NAME: 'brain_meta_viewer_annotation_layer',
    MAGIC_VIEWER_ANNOTATION_LAYER_NAME: 'magic_viewer_annotation_layer_name',
}

export const focusMode = {
    DO_NOTHING: 'DO_NOTHING',
    FINE_FOCUS: 'FINE_FOCUS',
    Z_STACK_MODE: 'Z_STACK_MODE'
}

export const objectiveTypeLiveMode = {
    NO_COVER_SLIP: 'HUNDRED_X',
    COVER_SLIP: 'FORTY_X'
}

export const slideViewerType = {
    NORMAL_SLIDE_VIEWER: 'NORMAL_SLIDE_VIEWER',
    TILE_SLIDE_VIEWER: 'TILE_SLIDE_VIEWER',
    GAMMA_SLIDE_VIEWER: 'GAMMA_SLIDE_VIEWER',
}

export const tileViewerPlotColors = {
    startOfStripColor: "#f0932b",
    endOfStripColor: "#888888",
    startOfSubpathColor: "#eb4d4b",
    endOfSubpathColor: "#e056fd",
    combBoundaryColor: "#27ae60",
    actualFocusColor: "#80ff00",
    plannedFocusColor: "#00BCFF",
    fftRatioCleanColor: "#000000", // was #299646
    fftRatioStrongColor: "#000000",
    fftRatioWeakColor: "#000000",
    doneFocusColor: "#f4c2c2",
    focusTrianglesColor: "#00ff00",
    focusFilterTrianglesColor: "#ff0000",
    tiltFocusPointColor: "#AAFF00",
    tiltFocusPointBlueColor: "#0096FF"
}

export const responsiveLayers = {
    LEVEL_0: 1600,
    LEVEL_1: 1500,
    LEVEL_2: 1400,
    LEVEL_3: 1300,
    LEVEL_4: 1150,
    LEVEL_5: 1000,
    LEVEL_6: 850,
    MOBILE_WIDTH_LEVEL: 730,
}

export const progressStage = {
    LOAD_SLIDES: "0",
    SET_PARAMETERS: "1",
    SCANNING: "2"
}

export const brushType = {
    REDRAW: "redraw",
    BRUSH: "brush",
    ERASER: "eraser"
}

export const brushShape = {
    SQUARE: "SQUARE",
    CIRCLE_S: "CIRCLE_S",
    CIRCLE_M: "CIRCLE_M",
    CIRCLE_L: "CIRCLE_L",
}

export const circleBrushSize = {
    CIRCLE_S: 10,
    CIRCLE_M: 36,
    CIRCLE_L: 70,
}

export const scanTypeVals = {
    WSI: "wsi",
    Z_STACK: "z_stack",
    BLOOD: "blood",
}

export const scanSettingsTypeVals = {
    GENERAL: "general",
    ADVANCED: "advanced"
}

export const pointSelectionModeVals = {
    COARSE: "coarse",
    FINE: "fine",
    CAMERA_SETTINGS: "camera_settings"
}

export const scanWorkflowLoadingMessages = {
    GETTING_IMAGE: 'Getting Image...',
    SET_EXPOSURE_VALUE: 'Setting Exposure value...',
    SET_GAMMA_VALUE: 'Setting Gamma value...',
    SET_COARSE_FOCUS_POINT: 'Setting Coarse Focus Point...',
    ADD_FINE_FOCUS_POINT: 'Adding Fine Focus Point...',
    REMOVE_FINE_FOCUS_POINT: 'Removing Fine Focus Point...',
    CALCULATE_FOCUS_POINTS: 'Calculating Focus Points...',
    LOADING: 'Loading...',
    EMPTY_MESSAGE: '',
    STITCHING: 'Stitching',
    RUNNING_AI: 'Running AI',
    SCAN_CRASHED: 'Scan Crashed'
}

export const StitchDirection = {
    LEFT: "LEFT_DIRECTION",
    RIGHT: "RIGHT_DIRECTION",
    UP: "UP_DIRECTION",
    DOWN: "DOWN_DIRECTION",
    UNKNOWN_DIRECTION: "UNKNOWN_DIRECTION"
}

export const bloodClass = {
    WBC: "WBC",
    FIELD: "FIELD",
    RBC: "RBC",
    PLT: "PLATELET"
}

export const bloodImageProperties = {
    HEIGHT: 2048, //Hard-coded, fetch from db
    WIDTH: 2448, //Hard-coded, fetch from db
}

export const C240SlideStatus = {
    INITIAL: "INITIAL", // white
    BARCODE_ONGOING: "BARCODE_ONGOING", // yellow
    PREVIEW_ONGOING: "PREVIEW_ONGOING", // yellow
    PREVIEW_DONE: "PREVIEW_DONE", // blue
    PREVIEW_IN_QUEUE: "PREVIEW_IN_QUEUE", // brown
    SCAN_IN_QUEUE: "SCAN_IN_QUEUE",// brown
    AUTO_SCAN_IN_QUEUE: "AUTO_SCAN_IN_QUEUE",
    SCAN_ONGOING: "SCAN_ONGOING",// yellow
    SCAN_DONE: "SCAN_DONE",// green
    SCAN_CRASHED: "SCAN_CRASHED", // red
    SCAN_STITCHING: "SCAN_STITCHING"
}

export const queueColorMap = {
    ADD: 1,
    REMOVE: 2,
    PRIORITISE: 3,
    PRIORITISE_ADD: 4,
}

export const queueActions = {
    ADD: 1,
    PRIORITISE: 2,
    REMOVE: 3,
    DEPRIORITISE: 4,
    REMOVE_PREVIEW_CALIBRATION: 5,
}

export const c240TaskType = {
    TAKE_SLIDE_PREVIEW: "TAKE_SLIDE_PREVIEW",
    TAKE_PREVIEW_FOR_CALIBRATION: "TAKE_PREVIEW_FOR_CALIBRATION",
    TAKE_AUTO_SCAN: "TAKE_AUTO_SCAN",
    TAKE_SCAN_OF_SELECTED_REGION: "TAKE_SCAN_OF_SELECTED_REGION",
    OPEN_GATE: "OPEN_GATE",
    DIRECT_SCAN: "DIRECT_SCAN",
    TAKE_BARCODE: "TAKE_BARCODE",
    PUT_CASSETTE_IN_RACK: "PUT_CASSETTE_IN_RACK",
}

export const queueLimits = {
    ALTER_TASK_ORDER: 0,
    REMOVE_TASK: 0,
}

export const viewerType = {
    "TISSUE": 1,
    "BLOOD": 2,
    "BLOOD40X": 3,
    "BMA40X": 4
}
export const AnnotationsConstants = {
    ALL_COLORS: "all_colors",
    ANNO_COLORS: {
        charcoal: '#36454f',
        lawnGreen: '#7CFC00',
        razzmatazz: '#e91e63',
        darkOrchid: '#9c27b0',
        violetBlue: '#3f51b5',
        buttonBlue: '#2196f3',
        hotPink: '#FF69B4',
        ao: '#008000',
        venetianRed: '#FF8C00',
    },
    ANNO_WIDTH: {
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 5,
        6: 6,
        7: 7,
        8: 8,
    },
    DEFAULT_ANNO_COLOR: "#36454f",
    LINE: "line",
    POLYGON: "polygon",
    CIRCLE: "circle",
    TOOL_TYPE: {
        ARROW: "Arrow",
        LABEL: "Label",
    },
    MAGIC_TOOL: "Magic Tool",
    ROI_TITLE: "Region of Interest",
    ROI_COLOR: morphleBaseTheme1.palette.primary.main,
    SELECTED_ANNOTATION: {
        COLOR_PRIMARY: '#ffff00',
        COLOR_SECONDARY: '#000000',
        WIDTH_PRIMARY: 3,
        WIDTH_SECONDARY: 6,
        FILL: 'rgba(255, 255, 255, 0.0)'
    }
}

export const TileViewerConstants = {
    TEXT_SIZE: {
        size0: '12',
        size1: '14',
        size2: '16',
        size3: '18',
        size4: '20',
        size5: '24',
    },
    TEXT_COLORS: {
        black: '#000000',
        white: '#FFFFFF',
        lawnGreen: '#7CFC00',
        razzmatazz: '#e91e63',
        buttonBlue: '#2196f3',
        hotPink: '#FF69B4',
    },
    DEFAULT_COLOR: "#000000",
    COUNTY: {
        0: 'rgba(124,252,0,0.65)',
        1: '#00ffff',
        2: 'rgb(255,140,0)',
        3: 'rgb(255,105,180)',
        4: 'rgb(255,255,0)',
        5: 'rgb(0,128,255)',
    },
    BLUE: {
        0: '#0000ff',
        1: 'rgb(255,105,180)',
        2: 'rgb(255,255,0)',
        3: 'rgb(0,128,255)',
    },
    THRESH_VALS: {
        0: 0.05,
        1: 0.1,
        2: 0.15,
        3: 0.2,
        4: 0.25,
        5: 0.3,
        6: 0.35,
        7: 0.4,
        8: 0.45,
        9: 0.5,
        10: 0.55,
        11: 0.6,
        12: 0.65,
        13: 0.7,
        14: 0.75,
        15: 0.8,
        16: 0.85,
        17: 0.9,
        18: 0.95,
    },
    TILE_COLORS: {
        0: '#000000',
        1: '#FFC000',
        2: '#FFFC00',
        3: '#FF0000',
        4: '#00FFFF',
        5: '#dfff4f',
        6: '#6600ff',
        7: '#0892d0',
        8: '#66ff00',
        9: '#0bda51',
    }
}

export const TiledStatus = ["Start Tiling", "In Progress"];

export const DeepBioConstants = {
    ALL_LABELS: "all_labels",
    LABELS: {
        'IDC-P': '#0000FF',
        Pattern3: '#FFFF00',
        Pattern4: '#FFA500',
        Pattern5: '#FF0000',
    },
    LABELS_LIST: ["Pattern3", "Pattern4", "Pattern5", "IDC-P"],
    LABEL_COLORS: ["", "", "", ""]
}

export const DeepBioIcon = (props) =>
    <Icon {...props}>
        <img style={{width: "90px", margin: "0px 0px 0px 0px"}} {...props} src={DeepBIoSVG} alt="DeepBioIcon"/>
    </Icon>;


export const IHCConstants = {
    RESULT_OPERATIONS: {
        ADD_POSITIVE: "add_positive",
        ADD_NEGATIVE: "add_negative",
        EDIT: "edit",
        DELETE: "delete",
    }
}

export const IHCIcon = (props) => <Science {...props} />;

export const SettingComponentType = {
    SLIDER: "SLIDER",
}

export const componentIds = {
    slideMaps: "slide-maps",
    rightBottomApps: "right-bottom-apps",
    morphleWatermark: "morphle-watermark",
    tawkIntegration: "tawk-integration",
    scaleLineControl: "scale-line-control"
}

export const ArchiveConstants = {
    ACTIVE: globalConfigurations.ARCHIVAL_ACTIVE === 'true',
    FRESH_ARCHIVE_DAYS: globalConfigurations.FRESH_ARCHIVE_DAYS || 30,
    RE_ARCHIVE_DAYS: globalConfigurations.RE_ARCHIVE_DAYS || 2,
    STATUS: {
        NOT_ARCHIVED: 0,
        ARCHIVING: 1,
        UPLOADED: 2,
        ARCHIVED: 3,
        RETRIEVAL_REQUESTED: 4,
        RETRIEVING: 5,
        RETRIEVED: 6,
        LOCAL_ARCHIVAL: 7,
    }
}

export const FileType = {
    IMAGE: "image",
    VIDEO: "video",
    SCREENSHOT: "screenshot",
    DOCUMENT: "document",
    LNMET: "lymphNodeMetastasis",
    OTHER: "other",
}

export const TawkBotConfig = {
    propertyId: "5f998d070ac0d3179f0e433b",
    widgetId: "1gdv3t82t",
}

export const DisplaySettingType = {
    SLIDE: 0,
    FIELD: 1,
}

export const HTSState = {
    OPENING_GATE: "OPENING_GATE",
    CLOSING_GATE: "CLOSING_GATE",
    HTS_AVAILABLE: "HTS_AVAILABLE",
    STAGE_CLEANING: "STAGE_CLEANING",
    BUSY: "BUSY"
}

export const ScreenshotExtensions = {
    JPEG: ".jpeg",
    PNG: ".png",
}

/**
 * EventNumberMap:
 *   1. The first entry is chosen as the default selection for the dropdown
 *   2. Do not modify the Custom Field Key, as it is a key. Duh!
 *   3. To change default value of custom event number, change the value after the dash.
 */
export const EventNumberMap = {
    WBCs: "100", //First one is chosen by default
    Anemia: "20",
    Platelets: "50",
    Leucocytosis: "200",
    Custom: "c-35" //Do not modify key,
}

export const MetsRiskFactor = {
    HIGH: 1,
    MEDIUM: 2,
    LOW: 3,
}

export const deviceType = {
    MORPHOLENS_1: "MORPHOLENS_1",
    MORPHOLENS_6: "MORPHOLENS_6",
    MORPHOLENS_240: "MORPHOLENS_240",
    HEMOLENS_1: "HEMOLENS_1",
    HEMOLENS_6: "HEMOLENS_6"
}

export const slideExportStatus = {
    // Status above 10 are reserved for errors
    NOT_DONE: 0,
    QUEUED: 1,
    QUEUED_PRIORITY: 2,
    IN_PROGRESS: 3,
    DONE: 4,

    ERROR: 10,
    FULL_STITCH_FAILED: 11,
    CANCELLED: 12
}

export const authenticationStatus = {
    PENDING: "PENDING",
    AUTHENTICATED: "AUTHENTICATED",
    UNAUTHENTICATED: "UNAUTHENTICATED"
}

export const slideUploadStatus = {
	NOT_STARTED: 0,
	IN_PROGRESS: 1,
	DONE: 2,
	ERROR: 3,
    LIMIT_BREACH: 4
}

export const slideTilingStatus = {
	TILING_NOT_DONE: 0,
	TILING_IN_PROGRESS: 1,
	TILING_DONE: 2,
	TILING_ERRORED_OUT: 3
}

export const SlotRegionSelectionConstants = {
    SELETION_FILL: {
        RED: 255,
        GREEN: 255,
        BLUE: 255,
        ALPHA: 76,
        RGBA: 'rgba(255, 255, 255, 0.3)'
    },
    SELECTION_BORDER: {
        RED: 255,
        GREEN: 255,
        BLUE: 255,
        ALPHA: 255,
        RGBA: 'rgba(255, 255, 255, 1)'
    },
    BLANK: {
        RED: 0,
        GREEN: 0,
        BLUE: 0,
        ALPHA: 0,
        RGBA: 'rgba(0, 0, 0, 0)'
    }
}

export const caseReadStatusEnum = {
    UNREAD: "0",
    READ: "1",
    ALL: "2",
}

export const caseArchiveStatusEnum = {
    ALL: "",
    ARCHIVED: "true",
    UNARCHIVED: "false",
}

export const slideStatusEnum = {
    SCANNING: "SCANNING",
    VIEWER_READY: "VIEWER_READY",
    ERRORED: "ERRORED",
    UNKNOWN: "UNKNOWN"
}

export const warrantyStatus = {
    EXPIRING_SOON : "EXPIRING_SOON",
    EXPIRED : "EXPIRED",
    VALID : "VALID"
}

export const CasePriority = [
    { label: "High", rank: 1 },
    { label: "Medium", rank: 2 },
    { label: "Low", rank: 3 },
]
export const C240ControlPanelTooltipMessageMap = (status) => {
    switch (status) {
        case C240SlideStatus.BARCODE_ONGOING:
            return "Taking Barcode";
        case C240SlideStatus.PREVIEW_ONGOING:
            return "Taking Preview";
        case C240SlideStatus.PREVIEW_IN_QUEUE:
            return "Preview Queued";
        case C240SlideStatus.SCAN_IN_QUEUE:
            return "Scan Queued";
        case C240SlideStatus.AUTO_SCAN_IN_QUEUE:
            return "Auto Scan Queued";
        default:
            return undefined;
    }
}

export const C240PromptType = {
    OPEN_GATE_PROMPT: "OPEN_GATE_PROMPT",
    CLOSE_GATE_PROMPT: "CLOSE_GATE_PROMPT",
    REMOVED_TASKS_PROMPT: "REMOVED_TASKS_PROMPT",
}

export const emailValidationPattern = /^$|^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export const defaultRotationDegree = 6;

export const DrawToolPixelTolerance = {
    HIGH_PIXEL_TOLERANCE: 20,
    LOW_PIXEL_TOLERANCE: 1,
}

export const zProfileFolderPath = `debug/zprofile/`

export const antdSpinLoaderIcon = <LoadingOutlined style={{fontSize: 50}} spin/>

export const antdSpinLoaderSmallIcon = <LoadingOutlined style={{fontSize: 25}} spin/>

export const Loader = ({loadingText}) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: loadingText ? '50vh' : 'auto'
        }}
    >
        <CircularProgress color="secondary"/>
        {loadingText && (
            <Typography sx={{marginTop: 2}} variant="body2" color="text.secondary">
                {loadingText}
            </Typography>
        )}
    </Box>
);

export const defaultScanTitle = "Morphle";

export const ErrorMessage = {
    NETWORK_ERROR: "Network Error: Please check your internet connection",
    SERVER_ERROR: "Server is unavailable, Please contact Morphle Support",
    UNAUTHORIZED_ERROR: "You are not authorized for this action!",
    BAD_GATEWAY_ERROR: "BAD GATEWAY: Server is unavailable, Please contact Morphle Support",
    NGINX_ERROR: "Please try reloading the page",
    TOKEN_EXPIRED_ERROR: "Token is expired, Authentication failed",
}

export const ErrorTypes = {
    NETWORK_MSG: "Network Error",
    NETWORK_CODE: "ECONNABORTED",
    NGINX_ERROR: "500 Internal Server Error"
}

export const defaultIHCAdvancedFields = [
    {
        key: "setupParameters",
        label: "Setup parameters",
        type: "header",
    },
    {
        key: "detectionImage",
        label: "Detection channel",
        value: "Red",
        unit: "",
        type: "choice",
        helperText: "Choose the channel that should be used for nucleus detection (e.g. DAPI)",
        options: ["Red", "Green", "Blue"]
    },
    {
        key: "detectionImageBrightfield",
        label: "Detection image",
        value: "Hematoxylin OD",
        unit: "",
        type: "choice",
        helperText: "Transformed image to which to apply the detection",
        options: ["Hematoxylin OD", "Optical density sum"]
    },
    {
        key: "requestedPixelSizeMicrons",
        label: "Requested pixel size",
        value: 0.5,
        unit: "µm",
        type: "input",
        helperText: "Choose pixel size at which detection will be performed - higher values are likely to be faster, but may be less accurate; set <= 0 to use the full image resolution"
    },
    {
        key: "nucleusParameters",
        label: "Nucleus parameters",
        type: "header",
    },
    {
        key: "backgroundRadiusMicrons",
        label: "Background radius",
        value: 8.0,
        unit: "µm",
        type: "input",
        helperText: "backgroundRadiusMicrons"
    },
    {
        key: "backgroundByReconstruction",
        label: "Use opening by reconstruction",
        value: true,
        type: "boolean",
        helperText: "backgroundByReconstruction"
    },
    {
        key: "medianRadiusMicrons",
        label: "Median filter radius",
        value: 0,
        unit: "µm",
        type: "input",
        helperText: "medianRadiusMicrons"
    },
    {
        key: "sigmaMicrons",
        label: "Sigma",
        value: 1.5,
        unit: "µm",
        type: "input",
        helperText: "sigmaMicrons"
    },
    {
        key: "minAreaMicrons",
        label: "Minimum area",
        value: 10.0,
        unit: "µm^2",
        type: "input",
        helperText: "minAreaMicrons"
    },
    {
        key: "maxAreaMicrons",
        label: "Maximum area",
        value: 400.0,
        unit: "µm^2",
        type: "input",
        helperText: "maxAreaMicrons"
    },
    {
        key: "intensityParameters",
        label: "Intensity parameters",
        type: "header",
    },
    {
        key: "threshold",
        label: "Threshold",
        value: 0.1,
        unit: "",
        type: "input",
        helperText: "threshold"
    },
    {
        key: "maxBackground",
        label: "Max background intensity",
        value: 2.0,
        unit: "",
        type: "input",
        helperText: "maxBackground"
    },
    {
        key: "watershedPostProcess",
        label: "Split by Shape",
        value: true,
        unit: "",
        type: "boolean",
        helperText: "watershedPostProcess"
    },
    {
        key: "excludeDAB",
        label: "Exclude DAB (membrane staining)",
        value: false,
        unit: "",
        type: "boolean",
        helperText: "excludeDAB"
    },
    {
        key: "cellParameters",
        label: "Cell parameters",
        type: "header",
    },
    {
        key: "cellExpansionMicrons",
        label: "Cell expansion",
        value: 25.0,
        unit: "µm",
        type: "input",
        helperText: "cellExpansionMicrons"
    },
    {
        key: "includeNuclei",
        label: "Include Cell Nucleus",
        value: true,
        unit: "",
        type: "boolean",
        helperText: "includeNuclei"
    },
    {
        key: "generalParameters",
        label: "General parameters",
        type: "header",
    },
    {
        key: "smoothBoundaries",
        label: "Smooth boundaries",
        value: true,
        unit: "",
        type: "boolean",
        helperText: "smoothBoundaries"
    },
    {
        key: "makeMeasurements",
        label: "Make measurements",
        value: true,
        unit: "",
        type: "boolean",
        helperText: "makeMeasurements"
    },
    {
        key: "intensityThresholdParameters",
        label: "Intensity threshold parameters",
        type: "header",
    },
    {
        key: "thresholdCompartment",
        label: "Score compartment",
        value: "Cell: DAB OD mean",
        unit: "",
        type: "choice",
        helperText: "Select the intensity measurement to threshold",
        options: ["Nucleus: DAB OD mean", "Nucleus: DAB OD max", "Cytoplasm: DAB OD mean", "Cytoplasm: DAB OD max", "Cell: DAB OD mean", "Cell: DAB OD max"]
    },
    {
        key: "thresholdPositive1",
        label: "Threshold 1+",
        value: 0.2,
        unit: "",
        type: "input",
        helperText: "Low positive intensity threshold"
    },
    {
        key: "thresholdPositive2",
        label: "Threshold 2+",
        value: 0.4,
        unit: "",
        type: "input",
        helperText: "Moderate positive intensity threshold"
    },
    {
        key: "thresholdPositive3",
        label: "Threshold 3+",
        value: 0.6,
        unit: "",
        type: "input",
        helperText: "High positive intensity threshold"
    },
    {
        key: "singleThreshold",
        label: "Single threshold",
        value: true,
        unit: "",
        type: "boolean",
        helperText: "Single Threshold"
    }
];